<template>
  <div id="data-edit-tab-info">

    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <img :src="files[0]" class="mr-8 rounded h-24 w-24" />
          <!-- <img :src="data.avatar" class="mr-8 rounded h-24 w-24" /> -->
          <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
          <div>
            <input type="file" id="fileD" class="hidden" ref="update_avatar_input" @change="update_avatar" accept="image/*">
            <vs-button class="mr-4" @click="$refs.update_avatar_input.click()">Change Profile Picture</vs-button>

            <!-- <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ data.name  }}</p>
            <input type="file" class="hidden" ref="update_avatar_input" @change="update_avatar" accept="image/*"> -->

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <!-- <vs-button class="mr-4 mb-4">Change Picture</vs-button> -->
            <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

            <!-- <vs-button type="border" color="danger">Remove Avatar</vs-button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Email" v-model="data_local.email" v-validate="'required'" name="email" />
        <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>

        <!-- <vs-input class="w-full mt-4" label="Is Activated" v-model="data_local.is_activated" v-validate="'required'" name="is_activated" />
        <span class="text-danger text-sm"  v-show="errors.has('is_activated')">{{ errors.first('is_activated') }}</span>  -->

        <div class="mt-4">
          <label class="vs-input--label">User Role</label>
          <v-select :options="optionUserRole" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.user_role_id" name="user_role_id"/>
          <span class="text-danger text-sm"  v-show="errors.has('user_role_id')">{{ errors.first('user_role_id') }}</span>
        </div>

        <vs-input class="w-full mt-4" label="Notes" v-model="data_local.notes" name="notes" />
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          ref="password"
          type="password"
          data-vv-validate-on="blur"
          v-validate="'required|min:6'"
          name="password"
          label="Password*"          
          placeholder="Password"
          v-model="password"
          class="w-full mt-4" />
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>  

        <vs-input
          type="password"
          v-validate="'required|min:6|confirmed:password'"
          data-vv-validate-on="blur"
          data-vv-as="password"
          name="confirm_password"
          placeholder="Confirm Password"
          label="Confirm Password*"
          v-model="confirm_password"
          class="w-full mt-4" />
        <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>
        
      </div>
    </div>


    <div class="vx-row mt-8">
      <div class="vx-col w-full md:w-1/2">
        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Personal Information</span>
        </div>

        <!-- Col Content -->
        <div>
          <div class="vx-colw-full">

            <div class="mt-4">
              <label class="vs-input--label">Salutation</label>
              <v-select :options="optionSalutation" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.salutation_id" name="salutation_id"/>
              <span class="text-danger text-sm"  v-show="errors.has('salutation_id')">{{ errors.first('salutation_id') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="First Name" v-model="data_local.first_name" type="first_name" v-validate="'required'" name="first_name" />
              <span class="text-danger text-sm"  v-show="errors.has('first_name')">{{ errors.first('first_name') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Middle Name" v-model="data_local.middle_name" type="middle_name" name="middle_name" />
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Last Name" v-model="data_local.last_name" type="last_name" v-validate="'required'" name="last_name" />
              <span class="text-danger text-sm"  v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Suffix" v-model="data_local.suffix" type="suffix" v-validate="'required'" name="suffix" />
              <span class="text-danger text-sm"  v-show="errors.has('suffix')">{{ errors.first('suffix') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Phone No" v-model="data_local.phone1" type="phone1" v-validate="'required'" name="phone1" />
              <span class="text-danger text-sm"  v-show="errors.has('phone1')">{{ errors.first('phone1') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Secondary Phone No" v-model="data_local.phone2" type="phone2" name="phone2" />
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Date of Birth" v-model="data_local.dob" type="date" v-validate="'required'" name="dob" />
              <span class="text-danger text-sm"  v-show="errors.has('dob')">{{ errors.first('dob') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Emergency Contact Name" v-model="data_local.emergency_contact_name" name="emergency_contact_name" />
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Emergency Contact No" v-model="data_local.emergency_contact_no" name="emergency_contact_no" />
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Relation" v-model="data_local.relation" name="relation" />
            </div>
          </div>
        </div>
      </div>

      <div class="vx-col w-full md:w-1/2">
        <!-- Col Header -->
          <div class="flex items-end md:mt-0 mt-base">
            <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
            <span class="leading-none font-medium">Address</span>
          </div>

        <!-- Col Content -->
        <div>
          <div class="vx-col w-full">
            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Address Line 1" v-model="data_local.address_line_1" type="address_line_1" v-validate="'required'" name="address_line_1" />
              <span class="text-danger text-sm"  v-show="errors.has('address_line_1')">{{ errors.first('address_line_1') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Address Line 2" v-model="data_local.address_line_2" type="address_line_2" v-validate="'required'" name="address_line_2" />
              <span class="text-danger text-sm"  v-show="errors.has('address_line_2')">{{ errors.first('address_line_2') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="State / Province" v-model="data_local.province" type="province" v-validate="'required'" name="province" />
              <span class="text-danger text-sm"  v-show="errors.has('province')">{{ errors.first('province') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="City" v-model="data_local.city" type="city" v-validate="'required'" name="city" />
              <span class="text-danger text-sm"  v-show="errors.has('city')">{{ errors.first('city') }}</span>
            </div>

            <div class="mt-4">
              <label class="vs-input--label">Country</label>
              <v-select :options="optionCountry" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.country_id" name="country_id"/>
              <span class="text-danger text-sm"  v-show="errors.has('country_id')">{{ errors.first('country_id') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Postcode" v-model="data_local.postcode" type="postcode" v-validate="'required'" name="postcode" />
              <span class="text-danger text-sm"  v-show="errors.has('postcode')">{{ errors.first('postcode') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '../../../../axios'

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      // uploading docs
      files: [],
      rawFiles: [],
      resDataLocal: [],
      resUp: [],

      //reading docs
      tableRead: [],
      files: [],

      token: localStorage.usertoken,
      optionUserRole: [],
      data_local: JSON.parse(JSON.stringify(this.data)),
      password: '',
      confirm_password: '',
      permissions: [{
        users: {
          'read': true,
          'write': false,
          'create': false,
          'delete': false
        },
        posts: {
          'read': true,
          'write': true,
          'create': true,
          'delete': true
        },
        comments: {
          'read': true,
          'write': false,
          'create': true,
          'delete': false
        }
      }],

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ]
    }
  },
  computed: {
    status_local: {
      get () {
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set (obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get () {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set (obj) {
        this.data_local.role = obj.value
      }
    },
    validateForm () {
      return !this.errors.any() && this.password !== '' && this.confirm_password !== ''
    }
  },
  methods: {
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    save_changes () {
      /* eslint-disable */

      this.data_local.password = this.confirm_password
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */

      const editId = this.$route.params.editId
      new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/user/save/${editId}`, {
              data: this.data_local,
              token: this.token
            })
            .then(res => {
              if(res['data'] != 'access_denied' && res['data'] != '') {

                //uploading docs
                if(res['data'] == 'success') {
                  //uploading docs
                  this.resDataLocal = res['data']['result']

                  this.$vs.notify({
                    color: 'success',
                    title: 'Data Saved',
                    text: 'The selected data was successfully Saved'
                  })

                  // this.$router.push({name:'app-user-view', params: {viewId: editId }})
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Saving Data',
                    text: 'Something went wrong'
                  })
                }

              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                this.$router.push({name:'app-user-view', params: {viewId: editId }})
              }

            })
            .catch(err => {
              this.$vs.notify({
                color: 'danger',
                title: 'Data Saving Error',
                text: 'The selected data was not saved'
              })
            }) 

            // uploading docs
            await axios.post(`/docs/table/save`, {
              rawFiles: this.rawFiles,
              token: this.token,
              id: editId,
              path: `docs/user/avatar/${editId}`,
              folderId: 3
            })

            this.$router.push({name:'app-user-view', params: {viewId: editId }})
        } catch(err) {
          reject(err.toString('utf8'));
        }      

      }) 
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
      this.$vs.notify({
        color: 'orange',
        title: 'Data Edit',
        text: 'The selected Data data was reset'
      })
    },
     // uploading docs
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },
    // uploading docs
    async update_avatar () {
      this.$vs.loading()

      var formdata = new FormData();
      $.each($('#fileD')[0].files, function(i, file) {
        formdata.append('fileD_'+i, file);
      });
      formdata.append('token', this.token)

      this.resUp = await axios.post(`/docs/upload`,  
        formdata, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        }
      )

      this.files = []
      for (const [key, value] of Object.entries(this.resUp.data.rawD)) {
        var imgB64 = this._arrayBufferToBase64( value.data.data )
        var imgAsc = imgB64.toString('ascii')
        this.files.push("data:image/png;base64, " + imgAsc)
      }

      if (this.resUp.data.uploadedD.length > 1) {
        for (const [key, value] of Object.entries(this.resUp.data.uploadedD)) {
          this.rawFiles.push(value)
        }
      } else {
        this.rawFiles[0] = this.resUp.data.uploadedD
      }

      setTimeout(() => {
        this.$vs.loading.close()
      }, 2000)
    },
    async loadData () {
      const viewId = this.$route.params.editId
      var d = new Promise(async(resolve, reject)  => {
        try {    
            await axios.get(`/user/view/${viewId}`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                // this.$router.push({name:'app-user-list'})
              } else {
                console.log('res d ', res['data'])
                resolve(res['data'][0])
              }

              this.$vs.loading.close()
            })
            .catch(err => {
              this.data_not_found = true
              this.$vs.loading.close()
            })

            //reading docs
            this.tableRead = await axios.post(`/docs/table/read/`, {
              token: this.token,
              path: `docs/user/avatar/${viewId}`,
              document_folder_id: 3
            })

            //reading docs
            for (const [key, value] of Object.entries(this.tableRead.data.uploadedD)) {
              var imgB64 = this._arrayBufferToBase64( value.data.Body.data )
              var imgAsc = imgB64.toString('ascii')
              this.files.push("data:image/png;base64, " + imgAsc)
            }            
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        // d.then((res) => {
        //   this.view_data = res[0]
        // })
      })

      await d
    },
    loadUserRole () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/userRole/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res user role ', res)
        this.optionUserRole = res
      })
    }    
  },
  created () {
    this.loadUserRole()
    this.data_local.password = null
    this.loadData()
  }
}
</script>
